<div class="full-width-image-container">
  <img src="../../assets/AdobeStock_3558442.jpeg" alt="Header Image">
</div>

<div class="top">
  <div>Do The <span>Right Thing</span></div>
  <div>On Point <span>With Safety</span></div>
  <div>Roll up <span>Your Sleeves</span></div>
</div>
<hr class="hr">
<br><br>

<div class="page-title">
  <h1 class="title-text">Human Resources</h1>
  <p class="form-desc">Forms, policies, and resources for Landpoint employees.</p>
</div>

@if (policyManualDoc; as policyDoc) {
  <p class="dev-p">
    <button type="button" class="quick-link-card" (click)="openDocument(policyDoc._id)">View Landpoint Policy Manual</button>
  </p>
}
<br>

<mat-card class="mat-mdc-elevation-specific mat-elevation-z8 wide-card">
  <mat-card-content>
    <h2 class="section-heading">HR Forms</h2>

    <div class="toolbar-row">
      <div class="breadcrumb">
        <button type="button" class="crumb" [class.current]="!currentNode" [disabled]="!currentNode" (click)="showCategories()">
          <mat-icon class="crumb-home">home</mat-icon>All Categories
        </button>
        @for (node of path; track node.key; let i = $index; let last = $last) {
          <mat-icon class="crumb-sep">chevron_right</mat-icon>
          @if (last) {
            <span class="crumb current">{{ node.label }}</span>
          } @else {
            <button type="button" class="crumb" (click)="goToCrumb(i)">{{ node.label }}</button>
          }
        }
      </div>
    </div>

    @if (formsLoading) {
      <div class="spinner-container">
        <mat-spinner diameter="36"></mat-spinner>
      </div>
    } @else {

      @if (!currentNode) {
        <div class="folder-grid">
          @for (node of hrTree; track node.key) {
            <div class="folder-card" (click)="enterNode(node)">
              <mat-icon class="folder-icon">folder</mat-icon>
              <div class="folder-text">
                <span class="folder-name">{{ node.label }}</span>
                @if (nodeDocTitles(node)) {
                  <span class="folder-docs">{{ nodeDocTitles(node) }}</span>
                }
              </div>
              <span class="folder-count" [class.empty]="nodeCount(node) === 0">{{ countLabel(nodeCount(node)) }}</span>
            </div>
          }
        </div>
      } @else if (currentNode.children) {
        <div class="folder-grid">
          @for (node of currentNode.children; track node.key) {
            <div class="folder-card" (click)="enterNode(node)">
              <mat-icon class="folder-icon">folder</mat-icon>
              <div class="folder-text">
                <span class="folder-name">{{ node.label }}</span>
                @if (nodeDocTitles(node)) {
                  <span class="folder-docs">{{ nodeDocTitles(node) }}</span>
                }
              </div>
              <span class="folder-count" [class.empty]="nodeCount(node) === 0">{{ countLabel(nodeCount(node)) }}</span>
            </div>
          }
        </div>
      } @else {
        @if (currentDocs.length === 0) {
          <div class="empty-state">
            <mat-icon>folder_open</mat-icon>
            <p>No documents in {{ currentNode.label }} yet.</p>
          </div>
        } @else {
          @for (doc of currentDocs; track doc._id) {
            <div class="doc-row">
              <div class="doc-main">
                <div class="doc-title-line">
                  <a class="doc-link" href="javascript:void(0)" (click)="openDocument(doc._id)">{{ doc.title }}</a>
                  @if (docNote(doc); as note) {
                    <span class="doc-note-line" [innerHTML]="linkifyEmails(note)"></span>
                  }
                </div>
                @if (doc.description && doc.description !== docNote(doc)) {
                  <div class="doc-desc-line" [innerHTML]="linkifyEmails(doc.description)"></div>
                }
              </div>
            </div>
          }
        }
      }
    }
  </mat-card-content>
</mat-card>
<br><br>

<h2 class="section-heading">Landpoint Careers</h2>
<div class="careers-row">
  <a class="quick-link-card" href="https://landpoint.applytojob.com/" target="_blank" rel="noopener noreferrer">Landpoint Careers Page</a>
  <span class="careers-note">Please contact Ana Lehnert at <a href="mailto:alehnert@landpoint.net">alehnert@landpoint.net</a> for guidance and to submit resumes.</span>
</div>
<br><br>

<h2 class="section-heading">Payroll Calendar</h2>
<div class="section-display">
  @if (payrollImageLoading) {
    <div class="spinner-container"><mat-spinner diameter="36"></mat-spinner></div>
  } @else if (payrollImageUrl) {
    <img [src]="payrollImageUrl" class="payroll-img" alt="Payroll Calendar" (click)="openPayrollImage()">
    @if (payrollImageEnlarged) {
      <div class="payroll-img-overlay" (click)="closePayrollImage()">
        <img [src]="payrollImageUrl" class="payroll-img-enlarged" alt="Payroll Calendar enlarged">
      </div>
    }
  } @else {
    <p class="note">Payroll calendar not available.</p>
  }
</div>
<br>

<h2 class="section-heading">Employee Referral Program</h2>
<div class="section-display">
  @if (referralImageLoading) {
    <div class="spinner-container"><mat-spinner diameter="36"></mat-spinner></div>
  } @else if (referralImageUrl) {
    <img [src]="referralImageUrl" class="referral-img" alt="Landpoint Employee Referral Program">
  } @else {
    <p class="note">Employee referral flyer not available.</p>
  }
</div>

<br><br>
